<template>
    <!--新闻详情-->

    <div class="box">
        <div class="news-title on-show-two">{{row.title}}</div>
         <div class="news-read-time">
                <span>阅读{{row.views_count}}</span>
                <span>{{row.create_time_ago}}</span>
        </div>
        <div class="fdown" v-if="row.files.length>0">
            文件下载
            <p v-for="(file,key) in row.files" :key="key" @click="download(file)">{{file.name}}</p>
        </div>
        <div class="news-content" v-html="row.content">
        </div>
        <!-- <div class="news-content" v-html="xx.content"></div> -->

        <van-action-sheet
                v-model="ltShow"
                :actions="ltActions"
                cancel-text="取消"
                @select="onLtSelect"
                close-on-click-action
                @cancel="ltShow=false"
        />


        <van-popup v-model="show_share_panel" position="bottom" :style="{ height: '30%' }" >
            <div class="share-panel">
                <div class="share-title">请选择分享方式</div>
                <!--<div class="share-desc">朋友通过你分享的页面成功报名后，你可获得对应的佣金。佣金可在会员中心-分销订单里查看</div>-->
                <div class="share-ul">
                    <div class="share-weixin" @click="shareWeixinFriend">
                        <p>微信好友</p>
                    </div>
                    <div class="share-timeline" @click="shareWeixinTimeLine">
                        <p>朋友圈</p>
                    </div>
                    <div class="share-copy" v-clipboard:copy="copy_text" v-clipboard:success="function(){copySuccess();show_share_panel=false }" >
                        <p>复制链接</p>
                    </div>
                </div>
            </div>
        </van-popup>

    </div>
   
</template>
<style scoped>
     .box{width: 7.1rem;
     height: 100vh;
     margin: 0.2rem auto;}
     .fdown{
         background-color: #f8f8f8;
         border-radius: 10px;
         padding: 10px;
         margin-top: 10px;
     }
     .fdown p{ color: #2b7aff ; text-decoration: blink ;
        font-size: 16px; margin-top: 20px;
     }
    .news-title{
       
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(34,34,34,1);
    }
    .news-read-time{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(153,153,153,1);
        margin-top: 0.2rem;
    }
    .news-content{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        margin-top: 20px;
        color:rgba(34,34,34,1);
        line-height:28px;
    }
    .news-content>>>img{max-width: 100% !important;}
</style>
<script>
    import Vue from 'vue';
    import { ActionSheet } from 'vant';
    import {getTimeFormat} from "../../../utils/date.js";

    Vue.use(ActionSheet);
    import jquery from 'jquery';
    jquery.fn.longPress = function(fn) {
        let timeout = 0;
        const $this = this;
        console.log('jquery.fn.longPress')
        for (let i = 0; i < $this.length; i++) {
            $this[i].addEventListener('touchstart', () => {
                timeout = setTimeout(fn, 800); // 长按时间超过800ms，则执行传入的方法
            }, false);
            $this[i].addEventListener('touchend', () => {
                clearTimeout(timeout); // 长按时间少于800ms，不会执行传入的方法
            }, false);
        }
    };

    export default {
        name: 'NewsDetail',
        components: {
        },
        data: function () {
            return {
                ltShow:false,
                copy_text:'',
                show_share_panel:false,
                ltImgSrc:'',
                ltImgName:'',
                ltActions:[{ name: '保存图片' }],
                row:{
                    id:0,
                    title:'2020年全国啦啦操公开赛日程安排及通知公告',
                    content:'',
                    files:''
                },
                share_data:{

                }
            }
        },
        filters: {
            getTimeFormat:getTimeFormat 
        },
        mounted() {
            let that = this;
            document.title = '新闻详情';
            this.row.id = this.$route.query.id;
             this.fetch();

            window.rbMessage = function (data) {
                if(data == 'showShare'){
                    that.show_share_panel = true;
                }
            }


        },
        watch: {
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onLtSelect(item){
                let that = this;
                switch (item.name){
                    case '保存图片':
                        console.log(that.ltImgSrc,that.ltImgName);
                        appEvent({
                            name: 'downloadPic',
                            query: {
                                'filename' : that.ltImgName,
                                'url' : that.ltImgSrc
                            }
                        });
                        break;
                }
            },
            download(file){
                appEvent({
                    name: 'downloadFile',
                    query: {
                        name:file.name,
                        url:file.url,
                    }
                });
            },
             fetch(){
                 let that = this;
                 that.$api.post('/api/cms/detail', {
                     id: that.row.id
                 }, (res) => {
                     that.row = res.data.data;
                     that.share_data = res.data.share_data;
                     that.copy_text=res.data.share_data.url;


                     if(window.isApp()){
                         setTimeout(()=>{
                             jquery('img').each(function(){
                                 jquery(this).longPress(() => {
                                     console.log('longPress',jquery(this).attr('src'));
                                     that.ltImgSrc = jquery(this).attr('src')
                                     that.ltImgName = jquery(this).attr('title')
                                     that.ltShow =  true;
                                 });
                             })
                         },500);
                         return false;
                     }

                 }, (res) => {
                     Toast.fail(res.msg);
                 })
             },


            shareWeixinFriend(){
                console.log('shareWeixinFriend')
                let that = this;
                if(window.isApp()){
                    appEvent({
                        name: 'shareWeixinFriend',
                        query: that.share_data
                    });
                }else{
                    this.showWxShare = true;
                    this.show_share_panel = false;
                }
            },
            shareWeixinTimeLine(){
                let that = this;
                if(window.isApp()){
                    appEvent({
                        name: 'shareWeixinTimeLine',
                        query: that.share_data
                    });
                }else{
                    this.showWxShare = true;
                    this.show_share_panel = false;

                }
            }

        }
    }
</script>



// WEBPACK FOOTER //
// NewsDetail.vue?d1c855b2